import React from 'react';

import { FormikProps } from 'formik';

// components
import StyledTextWithInfoTooltip from '../../../components/display/text/StyledTextWithInfoTooltip';
import styled from 'styled-components';

// constants
import aampeTheme from '../../../constants/aampeTheme';

// models
import { FormulaLabel } from '../../../models/formula.model';

import { FormulaCreateType } from '../FormulaCreateMainV2';
import FormulaLabels from './FormulaLabels';

interface FormulaLabelsSectionProps {
    formulaId?: number;
    formulaLabels: FormulaLabel[];
    createOrUpdateFormula?: FormulaCreateType;
    formikProps?: FormikProps<any>;
    hasWriteAccess: boolean;
}

const FormulaLabelsSection: React.FC<
    React.PropsWithChildren<FormulaLabelsSectionProps>
> = ({
    formulaId,
    formulaLabels,
    createOrUpdateFormula,
    formikProps,
    hasWriteAccess,
}) => {
    return (
        <LabelContainer>
            <StyledTextWithInfoTooltip
                text="Apply labels to the whole message"
                description={`Placing personalization labels here makes them apply to every message variant
                                                 within this message group. For example, if your whole message group applies to a single
                                                 offering or value proposition or is written in a single tone, place that label here to
                                                 save time and effort! (NOTE: For best results, use only one variant in this box - e.g. a
                                                 single offering or value proposition).`}
            />
            <StyledFormulaLabels
                formulaId={formulaId}
                formulaLabels={formulaLabels}
                formikProps={formikProps}
                createOrUpdateFormula={createOrUpdateFormula}
                hasWriteAccess={hasWriteAccess}
            />
        </LabelContainer>
    );
};

const LabelContainer = styled.div({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing(1),
    marginTop: aampeTheme.spacing(2),
});
const StyledFormulaLabels = styled(FormulaLabels)({
    gap: aampeTheme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
        margin: 0,
        gap: aampeTheme.spacing(3),

        '& > div': {
            flex: 1,
        },
    },
    '& > span': {
        width: 'fit-content',
    },
});

export default FormulaLabelsSection;
